import { render, staticRenderFns } from "./data39.vue?vue&type=template&id=ebd9dd64&scoped=true&"
import script from "./data39.vue?vue&type=script&lang=js&"
export * from "./data39.vue?vue&type=script&lang=js&"
import style1 from "./data39.vue?vue&type=style&index=1&id=ebd9dd64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd9dd64",
  null
  
)

export default component.exports